import React from 'react';
import CMSPage from '../../components/CMSPage/CMSPage';

const WaysToFlyPage = () => {
  return <CMSPage pageType="ways-to-fly" />;
};

export default WaysToFlyPage;
